export const TermsNotice = () => {
	return (
		<div className="my-8 flex flex-wrap justify-center gap-1 text-center text-sm text-gray-500 dark:text-gray-450">
			<span>By signing up, you agree to our </span>
			<a href="/terms" target="_blank">
				<span className="font-medium text-gray-700 hover:opacity-75 dark:text-gray-100">
					Terms & Conditions
				</span>
			</a>
			<span>and </span>
			<a href="/privacy" target="_blank">
				<span className="font-medium text-gray-700 hover:opacity-75 dark:text-gray-100">
					Privacy Policy
				</span>
			</a>
		</div>
	)
}
